import { Component, OnInit } from '@angular/core';
import { ArticleSearchResult } from '../../../../models/net/result/article-search-result';
import { AppService } from '../../../../services/app.service';
import { ArticleService } from '../../../../services/articles/article.service';
import { ActivatedRoute } from '@angular/router';
import { ArticleSearchRequest } from '../../../../models/net/request/article-search-request';
import { MessageSeverity } from '../../../../enums/message-severity';
import { TelemetorComponent } from '../../../base/telemetor/telemetor.component';

@Component({
    selector: 'app-article-cards',
    templateUrl: './article-cards.component.html',
    styleUrls: ['./article-cards.component.css', '../../../../app.component.css']
})

export class ArticleCardsComponent extends TelemetorComponent implements OnInit {

    public items: ArticleSearchResult[] | null = null;

    public constructor(public appService: AppService, public articleService: ArticleService, private route: ActivatedRoute) {

        super();
    }

    public override ngOnInit(): void {

        this.emitTelemetrigram("load");
    }

    public ngAfterViewInit(): void {

        const currentRoute = this.route.snapshot.routeConfig?.path

        let anonymousProductSearchRequest: ArticleSearchRequest = new ArticleSearchRequest();

        anonymousProductSearchRequest.BasicSearchString.IsWildPrefix = true;
        anonymousProductSearchRequest.BasicSearchString.IsWildSuffix = true;
        anonymousProductSearchRequest.BasicSearchString.SearchString = ""

        this.articleService.anonSearch(anonymousProductSearchRequest).subscribe((r: any | null) => {

            if (r) {

                this.items = r;
            }
        });
    }

    public viewArticle = (article: ArticleSearchResult): void => {

        let route: string | null = null;

        if (article.HtmlContentId) {

            if (article.HtmlContentMoniker) {

                route = "read/" + article.HtmlContentMoniker;

            } else {

                route = "view/" + article.HtmlContentId;
            }

            this.appService.navigateTo(route, "");
        }
    }
}
